export const settings = {
  apiUrl: process.env.VUE_APP_BASE_URL
  // apiUrl: 'https://lmmaps.pfriedrich.io/api'
  // apiUrl: 'http://localhost:5000/api'
  // apiUrl: 'https://mapsbackend.fz-shop.de/api'
};
